import React, { Component } from 'react';
import './App.css';

import { Route, Switch, BrowserRouter } from "react-router-dom";

import { Grid } from 'react-bootstrap';

import Header from "./components/Header";
import Index from "./pages/index";
import Exercise from "./pages/exercise";

import "bootstrap-css";

class App extends Component {
  render() {
    return (
      <BrowserRouter>
        <Grid>
          <Header/>
          <Switch>
            <Route exact path="/" component={Index}/>
            <Route exact path="/index.html" component={Index}/>
            <Route path="/exercise/:id" component={Exercise}/>
          </Switch>
        </Grid>
      </BrowserRouter>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js